import './helpers/wdyr';
import '../node_modules/normalize.css/normalize.css';
import React from 'react';
import { render } from 'react-dom';

import { PublicClientApplication } from '@azure/msal-browser';
// import * as Sentry from '@sentry/react';
// import { Integrations } from '@sentry/tracing';
import { msalConfig } from './config/authConfig';
import Root from './app/Root';

// const tracesSampleRate = (process.env.APP_ENV === 'PRODUCTION') ? 0.2 : 1.0;

/*
Sentry.init({
  dsn: 'https://bca4745e69134c5f9a676404af8a712b@o86597.ingest.sentry.io/6097490',
  integrations: [new Integrations.BrowserTracing()],
  environment: process.env.APP_ENV,
  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate,
});
*/

const msalInstance = new PublicClientApplication(msalConfig);

render(<Root msalInstance={msalInstance} />, document.getElementById('wrapper-app'));
